import React from "react";

import { styled } from "@mui/material/styles";
import Reveal from "../Animations/Reveal";

const MUITitle = styled("div")(({ theme }) => ({
  textAlign: "center",
  padding: "0 12rem",

  "@media screen and (orientation: landscape)": {
    position: "absolute",
    top: "0",
    height: "35.185%",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",

    ".children": {
      padding: "0 8rem",
      minWidth: "107.7rem",
      height: "20rem",
      // backdropFilter: "blur(0.8rem)",
      background: "rgba(35, 35, 35, 0.825)",
      borderRadius: "1rem",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",

      "& > *": {
        color: theme.palette.background.default,
      },
    },
  },
}));

interface TitleProps {
  children: React.ReactNode;
  className?: string;
  disableAnimation?: boolean;
}

const Title = React.memo<TitleProps>(
  ({ children, className, disableAnimation }) => {
    return (
      <MUITitle className={className}>
        <Reveal disabled={disableAnimation}>
          <div className="children">{children}</div>
        </Reveal>
      </MUITitle>
    );
  },
);

export default Title;
